import React from 'react';
import loadable from '@loadable/component';

const OffboardingDetailsComponent = loadable(() => import('./OffboardingDetails.container'));

export const OffboardingDetails = (props) => <OffboardingDetailsComponent {...props} />;
